import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import HandleSubscribeModal from "./Modals/HandleSubscribeModal";
import ProductAccessModal from "./Modals/ProductAccessModal";
import LoginOrSignUpModal from "./Modals/LoginOrSignUpModal";
import { useNavigate } from "react-router-dom";
import PolicyModal from "./Modals/PolicyModal";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function Products({ id, club, fetchData }) {
  const [subscription, setSubscription] = useState([]);
  const navi = useNavigate();
  const [handleSubscribeModal, setHandleSubscribeModal] = useState(false);
  const [payAsGo, setPayAsGo] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(0);
  const [selectedProd, setSelectedProd] = useState(null);
  const { user, dispatch } = useAuthContext();

  const [isLoading, setIsLoading] = useState(false);
  const [productAccessModal, setProductAccessModal] = useState(false);
  const [membership, setMembership] = useState([]);
  const [loginModal, setLoginModal] = useState(false);
  const [policyAgreement, setPolicyAgreement] = useState(null);
  const [policyModal, setPolicyModal] = useState(false);

  const cancelModal = () => {
    setHandleSubscribeModal(false);
    setProductAccessModal(false);
    setLoginModal(false);
    setPolicyModal(false);
  };

let ConvertToCurrency = (amount, country) => {
  let currency = "GBP"; // Default to GBP (GB)
  let locale = "en-GB"; // Default to British English

  // Set currency and locale based on country
  switch (country) {
    case "GB":
      currency = "GBP";
      locale = "en-GB";
      break;
    case "US":
      currency = "USD";
      locale = "en-US";
      break;
    case "AU":
      currency = "AUD";
      locale = "en-AU";
      break;
    case "CA":
      currency = "CAD";
      locale = "en-CA";
      break;
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
  }).format(amount);
};

  const handleCheckout = async (prodId, proId) => {
    if (user) {
      const productId = prodId;
      const BookingProfileId = proId;
      const transaction = { productId, BookingProfileId };

      try {
        const transResponse = await axios.post(
          `${ApiConnectionString}/api/Checkout`,
          transaction,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (transResponse.status === 200) {
          window.location.href = transResponse.data;
        }
      } catch (error) {
        if (error.status == 401) {
          dispatch({ type: "LOGOUT" });
          navi("/");
        }
        console.error("Error processing subscription:", error);
      }
    }
  };

  useEffect(() => {
    setIsLoading(true);

    const fetchClub = async () => {
      try {
        if (user) {
          try {
            const membershipResponse = await axios.get(
              `${ApiConnectionString}/api/ClubMembers/${user.id}/${id}`,
              {
                headers: { Authorization: `Bearer ${user.token}` },
              }
            );
            setMembership(membershipResponse.data);
            const policyResponse = await axios.get(
              `${ApiConnectionString}/api/PolicyAgreement/${user.id}/${id}`,
              {
                headers: { Authorization: `Bearer ${user.token}` },
              }
            );

            if (policyResponse.status == 200) {
              setPolicyAgreement(policyResponse.data);
            }
          } catch (error) {
            if (error.status == 401) {
              dispatch({ type: "LOGOUT" });
              navi("/");
            }
            console.error("Error fetching data:", error);
            setIsLoading(false);
          }
        }

        let subResponse;
        if (user) {
          subResponse = await axios.get(
            `${ApiConnectionString}/api/products?ClubId=${id}`,
            {
              headers: { Authorization: `Bearer ${user.token}` },
            }
          );
        } else {
          subResponse = await axios.get(
            `${ApiConnectionString}/api/products?ClubId=${id}`
          );
        }

        //Filtering out data with "payasgo" meta data to seperate this from recurring payments
        const filterSub = subResponse.data.filter(
          (product) => product.recurring == true
        );
        setSubscription(filterSub);
        //Filtering out data with "payasgo" meta data to seperate this from recurring payments
        const filterPayasGo = subResponse.data.filter(
          (product) => product.recurring == false
        );
        setPayAsGo(filterPayasGo);

        setIsLoading(false);
      } catch (error) {
        if (error.status == 401) {
          dispatch({ type: "LOGOUT" });
          navi("/");
        }
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };

    fetchClub();
  }, [user, id]);

  if(isLoading){
    return(
      <div>
        <LoadingSpinner />
      </div>
    )
  }

  return (
<div className="container">
  <div className="row">
    {/* Subscriptions Section */}
    {subscription.length > 0 && (
      <div className="col-md-6">
        <div className="customNav rounded">
          <p className="p-2 fw-bold">Subscriptions</p>
        </div>
        {subscription.map((prod) => (
          <div key={prod.id}>
            <div className="d-flex justify-content-between fw-bold">
              <p className="mb-0">{prod.name}</p>
              <p className="mb-0">
                {ConvertToCurrency(prod.price / 100, club.country)}
              </p>
            </div>
            <p className="mt-1">{prod.description}</p>
            <p>
              {prod.interval.charAt(0).toUpperCase() + prod.interval.slice(1)}
              ly recurring payment
            </p>
            <p
              className="oc-red-button p-1 fw-bold pointer"
              onClick={() => {


                if (!user) {
                  setLoginModal(true);
                  return;
                }
                if (club.policyUpdated != null) {
                  if (
                    !policyAgreement ||
                    club.policyUpdated > policyAgreement.policyUpdated
                  ) {
                    setPolicyModal(true);
                    return;
                  }
                }
                setSelectedProductId(prod.id);
                setSelectedProd(prod);
                setHandleSubscribeModal(true);
              }}
            >
              Subscribe
            </p>
            {prod.totalAccess ? (
              <p className="text-muted mt-4">
                This subscription provides access to all classes of this club.
              </p>
            ) : (
              <p className="text-muted mt-4">
                This subscription provides access to a limited selection of
                classes. Click "
                <span
                  style={{
                    color: "blue",
                    cursor: "pointer",
                    fontWeight: "normal",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.textDecoration = "underline")
                  }
                  onMouseOut={(e) => (e.target.style.textDecoration = "none")}
                  onClick={() => {
                    setSelectedProductId(prod.id);
                    setProductAccessModal(true);
                  }}
                >
                  View Class Access
                </span>
                " to see the available options.
              </p>
            )}
            <hr />
          </div>
        ))}
      </div>
    )}

    {/* Flexible Class Passes Section */}
    {payAsGo.length > 0 && (
      <div className="col-md-6">
        <div className="customNav rounded">
          <p className="p-2 fw-bold">Flexible Class Passes</p>
        </div>
        {payAsGo.map((prod) => (
          <div key={prod.id}>
            <div className="d-flex justify-content-between fw-bold">
              <p className="mb-0">{prod.name}</p>
              <p className="mb-0">
                {ConvertToCurrency(prod.price / 100, club.country)}
              </p>
            </div>
            <p className="mt-1">{prod.description}</p>
            <p className="fw-bold red-text mb-0">Classes: {prod.token}</p>
            <p className="text-muted mt-0">
              Book {prod.token} classes whenever you like.
            </p>
            <p
              className="oc-red-button p-1 fw-bold pointer"
              onClick={() => {
                if (!user) {
                  setLoginModal(true);
                  return;
                }
                if (club.policyUpdated != null) {
                  if (
                    !policyAgreement ||
                    club.policyUpdated > policyAgreement.policyUpdated
                  ) {
                    setPolicyModal(true);
                    return;
                  }
                }
                handleCheckout(prod.id);
              }}
            >
              Buy
            </p>
            {prod.totalAccess ? (
              <p className="text-muted mt-4">
                This payment option provides access to all classes of this
                club.
              </p>
            ) : (
              <p className="text-muted mt-4">
                This payment option provides access to a limited selection of
                classes. Click "
                <span
                  style={{
                    color: "blue",
                    cursor: "pointer",
                    fontWeight: "normal",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.textDecoration = "underline")
                  }
                  onMouseOut={(e) => (e.target.style.textDecoration = "none")}
                  onClick={() => {
                    setSelectedProductId(prod.id);
                    setProductAccessModal(true);
                  }}
                >
                  View Class Access
                </span>
                " to see the available options.
              </p>
            )}
            <hr />
          </div>
        ))}
      </div>
    )}
  </div>

      {handleSubscribeModal && (
        <HandleSubscribeModal
          cancelModal={cancelModal}
          handleSubscribe={handleCheckout}
          selectedProductId={selectedProductId}
          selectedProd={selectedProd}
          id={id}
        />
      )}
      {productAccessModal && (
        <ProductAccessModal id={selectedProductId} cancelModal={cancelModal} />
      )}
      {loginModal && <LoginOrSignUpModal cancelModal={cancelModal} />}
      {policyModal && (
        <PolicyModal
          cancelModal={cancelModal}
          clubId={id}
          fetchData={fetchData}
        />
      )}
</div>

  );
}
